/**
 * @description 定义全局方法
 */

import { GLOBAL_STATUS } from './state'

// 全局方法
export function formatSceneType (sceneInfo: any): string {
    return sceneInfo ? (sceneInfo.courseTypeName + "-" + sceneInfo.sceneTypeName) : '未知场景';
}
